const formatToCamelCase = (input: string): string =>
  input.toLowerCase().replace(/_([a-z])/g, (_, char) => char.toUpperCase());

export default formatToCamelCase;
